var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zsxq"},[(_vm.facility=='app')?_c('div',{staticClass:"content"},[_c('AbApp')],1):_c('div',{staticClass:"pc"},[_c('Pc')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }